import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { LensConfigMode } from "../model/configuration/configuration";
import { LensOrderItem } from "../model/order/order";

@Injectable({
    providedIn: 'root'
})
export class ReturnStoreService {
  
    item: LensOrderItem;
    item$: Subject<LensOrderItem> = new Subject<LensOrderItem>();

    lensConfigMode: LensConfigMode = LensConfigMode.SINGLE;
    
    isRightSideEnable$: Subject<boolean> = new Subject<boolean>();
    isRightSideEnable: boolean = false;
    isLeftSideEnable$: Subject<boolean> = new Subject<boolean>();
    isLeftSideEnable: boolean = false;

    constructor()  {
        this.isRightSideEnable$.subscribe((value) => {
            this.isRightSideEnable = value;
        });

        this.isLeftSideEnable$.subscribe((value) => {
            this.isLeftSideEnable = value;
        });
    }

    public setIsRightSideEnable(isEnable: boolean) {
        this.isRightSideEnable = isEnable;
    }

    public getIsRightSideEnable(): boolean {
        return this.isRightSideEnable;
    }

    public toggleIsRightSideEnable() {
        if(this.isRightSideEnable) {
            this.isRightSideEnable$.next(false);            
        } else {
            this.isRightSideEnable$.next(true);
        }
    }

    public setIsLeftSideEnable(isEnable: boolean) {
        this.isLeftSideEnable = isEnable;
    }

    public getIsLeftSideEnable(): boolean {
        return this.isLeftSideEnable;
    }

    public toggleIsLeftSideEnable() {
        if(this.isLeftSideEnable) {
            this.isLeftSideEnable$.next(false);            
        } else {
            this.isLeftSideEnable$.next(true);
        }
    }

    public getLensConfigMode(): LensConfigMode {
        return this.lensConfigMode;
    }
  
    public getItem(): LensOrderItem {
        return this.item;
    }
  
    public setItem(item: any) {
        this.item = item;
        this.item$.next(item);
    }
}